<template>
  <custom-callout
    border-color="primary-2"
    class="mb-4 custom-callout rounded"
    :has-toggle="false"
  >
    <div class="py-2">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-3 mt-md-0 mt-sm-5"
          :gradient="false"
          icon="fas fa-undo mb-1"
          icon-color="#ff7058"
          icon-size="16px"
          :title="title"
        />
      </div>
      <div>
        <div class="font-14 color-gray-6 mb-1">
          Comentario:
        </div>
        <p class="font-16 font-weight-normal color-black">
          {{ comment }}
        </p>
      </div>
    </div>
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';

export default {
  name: 'CardStatusTransition',
  components: {
    IconView,
    CustomCallout,
  },
  props: {
    comment: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
